/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolbar_Secondary_Import_Media_Aria_LabelInputs */

const en_toolbar_secondary_import_media_aria_label = /** @type {(inputs: Toolbar_Secondary_Import_Media_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import Media`)
};

const fr_toolbar_secondary_import_media_aria_label = /** @type {(inputs: Toolbar_Secondary_Import_Media_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation de Média`)
};

const de_toolbar_secondary_import_media_aria_label = /** @type {(inputs: Toolbar_Secondary_Import_Media_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importmedien`)
};

const it_toolbar_secondary_import_media_aria_label = /** @type {(inputs: Toolbar_Secondary_Import_Media_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa media`)
};

const ru_toolbar_secondary_import_media_aria_label = /** @type {(inputs: Toolbar_Secondary_Import_Media_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт медиафайлов`)
};

const es_toolbar_secondary_import_media_aria_label = /** @type {(inputs: Toolbar_Secondary_Import_Media_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar medios`)
};

const zh_cn2_toolbar_secondary_import_media_aria_label = /** @type {(inputs: Toolbar_Secondary_Import_Media_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进口媒体`)
};

const ja_toolbar_secondary_import_media_aria_label = /** @type {(inputs: Toolbar_Secondary_Import_Media_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアのインポート`)
};

const hi_toolbar_secondary_import_media_aria_label = /** @type {(inputs: Toolbar_Secondary_Import_Media_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयात मीडिया`)
};

const pt_pt2_toolbar_secondary_import_media_aria_label = /** @type {(inputs: Toolbar_Secondary_Import_Media_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar mídia`)
};

/**
* | output |
* | --- |
* | "Import Media" |
*
* @param {Toolbar_Secondary_Import_Media_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toolbar_secondary_import_media_aria_label = /** @type {((inputs?: Toolbar_Secondary_Import_Media_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolbar_Secondary_Import_Media_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_toolbar_secondary_import_media_aria_label(inputs)
	if (locale === "de") return de_toolbar_secondary_import_media_aria_label(inputs)
	if (locale === "it") return it_toolbar_secondary_import_media_aria_label(inputs)
	if (locale === "ru") return ru_toolbar_secondary_import_media_aria_label(inputs)
	if (locale === "es") return es_toolbar_secondary_import_media_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_toolbar_secondary_import_media_aria_label(inputs)
	if (locale === "ja") return ja_toolbar_secondary_import_media_aria_label(inputs)
	if (locale === "hi") return hi_toolbar_secondary_import_media_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_toolbar_secondary_import_media_aria_label(inputs)
	return en_toolbar_secondary_import_media_aria_label(inputs)
});